<div class="input-borders" 
  [ngClass]="{ 'error': isError, 'active': isFocused && !isError, 'readonly': readonly }">
  <div class="input">
    <span class="input-label">{{ label }}</span>
    <ion-input
      class="input-field"
      [ngClass]="{ 'error': isError, 'readonly': readonly }"
      [disabled]="disabled"
      placeholder=""
      [readonly]="readonly"
      [(ngModel)]="value"
      [type]="format"
      [maxlength]="maxLength"
      (ionInput)="filterInput($event)"
      (ionChange)="onChange($event)"
      (ionFocus)="onFocus()"
      (ionBlur)="onBlur()"
      (keypress)="onKeyPress($event)"
    >
    </ion-input>
  </div>
  <ion-icon 
    class="edit-icon"
    *ngIf="allowToggleToEditMode && readonly" 
    src="assets/edit_button.svg"
    (click)="setEditMode()"
  ></ion-icon>
  <span 
    class="save-btn"
    *ngIf="allowToggleToEditMode && !readonly"
    (click)="save()"
  >save</span>
</div>